import styled from 'styled-components'
import Slider from 'react-slick'
import { Button } from 'reactstrap'

export const SliderContainer = styled.div`
    position: relative;
`

export const PlantDetailsImage = styled.img`
    width: ${(window ? `${window.innerWidth}px !important` : '100%')};
    height: ${(window ? `${window.innerWidth}px !important` : '200px')};
    max-height: 500px;
    object-fit: cover;
`

export const PlantDetailsImageShadow = styled.div`
    width: ${(window ? `${window.innerWidth}px` : '100%')};
    // height: ${(window ? `${window.innerWidth / 4}px` : '200px')};  
    background: linear-gradient(transparent, #fff);
    position: absolute;
    bottom: -1px;
`

export const ImageSlider = styled(Slider)`
    .slick-dots {
        z-index: 3;
        bottom: 10px;
    }
`

export const PlantDetailsHeader = styled.div`
    background-color: #fff;
`

export const PlantName = styled.h1`
    padding: 30px 10px 0 10px;
    margin: 0;
    text-align: center;
    font-size: 1.8rem;
`

export const PlantLatinName = styled.h2`
    padding: 10px;
    text-align: center;
    font-size: 1.2rem;
    color: var(--secondary);
`

export const PlantActionsContainer = styled.div`
    padding: 10px;
    text-align: center;
`

export const PlantActionsButton = styled(Button)`
    margin: 5px;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Plants/PlantDetails.js